export default "__VITE_ASSET__CWxwkQ8m__"